import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PortalAuthService } from '../../core/portal-auth.service';
import { PortalApiService } from '../../core/portal-api.service';
import { I18nService } from '../../core/i18n.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'portal-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email = '';
  password = '';
  busy = false;
  error = '';
  info = '';
  mode: 'signin' | 'reset' = 'signin';
  supportEmail = environment.supportEmail;

  constructor(
    private auth: PortalAuthService,
    private api: PortalApiService,
    private route: ActivatedRoute,
    private router: Router,
    public i18n: I18nService
  ) { }

  ngOnInit() {
    // The guard redirects here with the server's own explanation when a valid
    // Firebase sign-in is not a valid portal account — showing it beats a bare
    // login screen that looks like the password was wrong.
    const reason = this.route.snapshot.queryParamMap.get('reason');
    if (reason) { this.error = reason; }
  }

  async signIn() {
    if (!this.email || !this.password) {
      this.error = this.i18n.t('login.errorEnterCredentials');
      return;
    }
    this.busy = true; this.error = ''; this.info = '';
    try {
      await this.auth.signIn(this.email, this.password);
      // Signing in to Firebase only proves the credential. Load the session so
      // an account without portal access is stopped here, with an explanation,
      // instead of inside an empty dashboard.
      const session: any = await this.api.me();
      if (!session || !session.success) { throw new Error('No portal access'); }
      this.auth.setSession(session);
      this.router.navigate(['/employees']);
    } catch (err: any) {
      await this.auth.signOut(false);
      // A server-supplied message (e.g. an invalid-credential reason from
      // Firebase Auth, funnelled through portal-auth.service.ts) is shown
      // as-is — it is not in this dictionary, see translations.ts's scope note.
      this.error = err && err.error && err.error.message
        ? err.error.message
        : (err && err.message) || this.i18n.t('login.errorSignInFailed');
    }
    this.busy = false;
  }

  async sendReset() {
    if (!this.email) {
      this.error = this.i18n.t('login.errorEnterEmail');
      return;
    }
    this.busy = true; this.error = ''; this.info = '';
    try {
      await this.auth.sendPasswordReset(this.email);
      this.info = this.i18n.t('login.infoResetSent');
      this.mode = 'signin';
    } catch (err: any) {
      this.error = (err && err.message) || this.i18n.t('login.errorResetFailed');
    }
    this.busy = false;
  }

  switchTo(mode: 'signin' | 'reset') {
    this.mode = mode;
    this.error = '';
    this.info = '';
  }
}
